import { normalSanatizerBRL } from "src/utils/functions";
import { ResultDecimo } from "../decimo-terceiro";
export const DecimoTerceiroTable = ({ results }: { results: ResultDecimo }) => {
  return (
    <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
      <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
        <thead className="bg-gray-200 sticky top-0">
          <tr>
            <th className="px-4 py-2 text-center truncate">Evento</th>
            <th className="px-4 py-2 text-center truncate">Ref.</th>
            <th className="px-4 py-2 text-center truncate">Proventos</th>
            <th className="px-4 py-2 text-center truncate">Descontos</th>
          </tr>
        </thead>
        <tbody>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Valor Parcela Bruta
            </td>
            <td className="px-4 py-2 text-center truncate border-r">-</td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.proventos)}
            </td>
            <td className="px-4 py-2 text-center truncate">-</td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Adiantamento 1ª Parcela 13º
            </td>
            <td className="px-4 py-2 text-center truncate border-r">-</td>
            <td className="px-4 py-2 text-center truncate border-r">-</td>
            <td className="px-4 py-2 text-center truncate">-</td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">INSS</td>
            <td className="px-4 py-2 text-center truncate border-r">
              {results.porcentagemINSS}%
            </td>
            <td className="px-4 py-2 text-center truncate border-r">-</td>
            <td className="px-4 py-2 text-center truncate">
              R$ {normalSanatizerBRL(results.descontoINSS)}{" "}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">IRRF</td>
            <td className="px-4 py-2 text-center truncate border-r">
              {results.porcentagemIRRF}%
            </td>
            <td className="px-4 py-2 text-center truncate border-r">-</td>
            <td className="px-4 py-2 text-center truncate">
              R$ {normalSanatizerBRL(results.descontoIRRF)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">Totais</td>
            <td className="px-4 py-2 text-center truncate border-r">-</td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.proventos)}
            </td>
            <td className="px-4 py-2 text-center truncate">-</td>
          </tr>
          <tr className="border-b">
            <td className="px-4 py-2 text-center border-r">
              DECIMO TERCEIRO LIQUIDO
            </td>
            <td className="px-4 py-2 text-center truncate border-r">-</td>
            <td className="px-4 py-2 text-center  truncate border-r">
              R$ {normalSanatizerBRL(results.valorfinal)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
